module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-135.1b968d81.jpg";